import { Component, inject, OnInit, Inject, NgZone, ChangeDetectorRef } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
import { GoPayCommonsService } from "src/app/services/go-pay-commons.service";
import { ENV_CONFIG } from "@tae/tokens";
import {
  CatalogosService,
  CryptoService,
  DeviceInfoService,
  MainService,
  StorageService,
} from "@tae/services";
import { ActivatedRoute, Router } from "@angular/router";
import { CODE_ERRORS } from "@tae/constants";
import { ErrorMessageInterface } from "src/app/interfaces/error-message.interface";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { DialogErrorComponent } from "src/app/components/dialog-error/dialog-error.component";
import { SSOValidateInterface } from "src/app/interfaces/catalogos.interface";
import { Accounts, BillerInterface } from "@tae/interfaces";
import { AppLoadService } from "src/app/services/app-load.service";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { TaggingService } from "src/app/services/tagging.service";
import * as CryptoJS from "crypto-js";
import { RechargeHistoryInterface } from "src/app/interfaces/recharge-history.interface";
import { RechageType } from "src/app/types/recharge-history.type";
import { logoCompaniesFixture } from "src/app/fixtures/history.fixture";
import { PictureBasicCardInterface } from "src/app/interfaces/basic-card.interface";
/**
 * Metodo para realizar llamado a funcion nativa
 *  con la que se finaliza la  aplicacion
 */
declare function quitApp(): any;
/*
  Devuelve la información del dispositivo por RSA
 */
declare function obtainCollectData(): any;
/*
  Devuelve el detalle de las tarjetas del cliente
 */
declare function retrieveCards(): any;

declare function hideBackButton(): void;
@Component({
  selector: "app-history",
  templateUrl: "./history.component.html",
  styleUrls: ["./history.component.scss"],
  standalone: false
})
export class HistoryComponent implements OnInit {
  #gpc = inject(GoPayCommonsService);

  #ctrlRecharge = inject(CtrlRechargeService);

  #storageService = inject(StorageService);

  #route = inject(ActivatedRoute);

  #mainService = inject(MainService);

  #bss = inject(BottomSheetService);

  #catalogsService = inject(CatalogosService);

  #ngZone = inject(NgZone);

  #infoService = inject(DeviceInfoService);

  #cryptoService = inject(CryptoService);

  #router = inject(Router);

  #als = inject(AppLoadService);

  #taggingService = inject(TaggingService);

  private cdr = inject(ChangeDetectorRef);

  rechargeHistory: RechageType[] = []

  get textTokens(): any {
    return this.#ctrlRecharge.textTokens;
  }

  constructor(@Inject(ENV_CONFIG) private readonly _environment) {
    const token = this.#route.snapshot.queryParamMap.get("token");
    if (token) {
      this.anonimized(token);
    }
    window["angularComponentRef"] = {
      component: this,
      zone: this.#ngZone,
      loadAngularFunction: (command, data) => {
        switch (command) {
          case "GET_CARDS":
            this.#ctrlRecharge.cardsData = data?.map((card) => {
              let { imageCode, cardNumber } = card;
              return { imageCode, cardNumber };
            });
            this.#ctrlRecharge.showDirectory = true;
            break;
          case "RSA":
            if (data?.GeoLocationInfo && data?.GeoLocationInfo[0]) {
              let { Latitude, Longitude } = data?.GeoLocationInfo[0];
              let location = `${Latitude},${Longitude}`;
              let date = new Date();
              let geoLocation = {
                location: location,
                date: date,
              };
              this.#storageService.set("objGeo", JSON.stringify(geoLocation));
            } else {
              this.retryGeolocalization();
            }
            break;
          case "error":
            console.warn("callbacks not found");
            break;
        }
      },
    };
  }

  private anonimized(_token: string): void {
    let anonimized = CryptoJS.SHA1(_token).toString();
    this.#storageService.set("anonimized", anonimized);
  }

  async ngOnInit(): Promise<void> {
    console.log('init');

    if (this.#ctrlRecharge.accounts?.length) {
      this.#ctrlRecharge.resetRecharge();
      this.rechargeHistory = this.buildRecharges();
      return;
    }
    this.#mainService.showSpinner(true);
    this.#ctrlRecharge.textTokens = await firstValueFrom(
      this.#gpc.getTextTokens()
    );
    try {
      hideBackButton();
      retrieveCards();
    } catch (error) {
      console.log(error);
    }
    await this.#als.initializeApp();
    this.getToken();
    // this.cdr.detectChanges();
  }

  #sendTaggin(): void {
    const pageView: PageViewInferface = {
      url: "recarga_celular/",
      titulo: "recarga_celular",
      canalBanco: "supermovil",
      subsection1: "recarga_celular",
      versionApp: '',
      userId: "",
      entorno: this.#storageService.get("ENV"),
      event: "PageView",
    };
    this.#taggingService.setPageView(pageView);
  }

  onBack(): void {
    try {
      quitApp();
    } catch (error) {
      console.log(error);
    }
  }
  /* Consulta el servicio de catalogos*/
  private getToken() {
    const tokenSSO =
      this.#storageService.get("token") !== "null"
        ? decodeURIComponent(this.#storageService.get("token"))
        : this.#route.snapshot.queryParamMap.get("token");
    if (tokenSSO) {
      this.anonimized(tokenSSO);
      this.#catalogsService
        .getCatalogos(JSON.stringify({ tokenSSO: tokenSSO }))
        .subscribe({
          next: (_response) => this.evaluteSSO(_response),
          error: (_error) => {
            const { message, code, status, title, image, icon } =
              CODE_ERRORS["STATUS_RESPONSE_CAT"];
            this.errorMessage({
              message,
              code,
              status,
              title,
              pathImage: image,
              icon: icon,
            });
          },
        });
    } else {
      const { message, code, status, title, image, icon } =
        CODE_ERRORS["STATUS_RESPONSE_SSO"];
      this.errorMessage({
        message,
        code,
        status,
        title,
        pathImage: image,
        icon: icon,
      });
    }
  }
  /**
   *
   * @param { ErrorMessageInterface }_settings
   */
  errorMessage(_settings: ErrorMessageInterface): void {
    this.#mainService.showSpinner(false);
    const settings = {
      ..._settings,
      pathImage: _settings.pathImage || "ta-disconnected",
      icon: _settings.icon || "plug",
      buttonLabel:
        _settings.buttonLabel || this.textTokens.ERROR_MESSAGE_ACCEPT,
      closeLabel: _settings.closeLabel || this.textTokens.ERROR_MESSAGE_CLOSE,
    };
    const dataBSS = {
      _data: settings,
      close: () => this.onCloseError(settings.status),
      config: {
        closeLabel: settings.closeLabel,
      },
    };
    this.#bss.show(DialogErrorComponent, dataBSS);
  }

  onCloseError(status: string): void {
    this.#bss.hide();
    if (
      status &&
      (
        status === "STATUS_RESPONSE_CAT" ||
        status === "STATUS_RESPONSE_KE" ||
        status === "STATUS_RESPONSE_SSO" ||
        status === "STATUS_RESPONSE_CTAS" ||
        status === "STATUS_RESPONSE_GEO" ||
        status === "STATUS_RESPONSE_TYC" ||
        status === "STATUS_NO_ACC"
      )
    ) {
      try {
        quitApp();
      } catch (error) {
        console.warn("dev env: ", status);
      }
    }
  }

  async evaluteSSO(response: SSOValidateInterface): Promise<void> {
    if (response.status.statusCode === "FORW00") {
      const { message, code, status, title, image, icon } =
        CODE_ERRORS["STATUS_RESPONSE_SSO"];
      this.errorMessage({
        message,
        code,
        status,
        title,
        pathImage: image,
        icon: icon,
      });
      return;
    }
    try {
      await this.checkTerms(response);
      obtainCollectData();
      // retrieveCards();
      setTimeout(() => {
        if (this.#storageService.get("objGeo")) {
          this.processRequests(response);
          return;
        }
        this.buildGeolocalizacion(response);
      }, 500);
    } catch (error) {
      this.#handleSSOError(error);
    }
  }

  private checkTerms(
    response: SSOValidateInterface
  ): Promise<SSOValidateInterface> {
    return new Promise((resolve, reject) => {
      if (
        response["data"] &&
        response["data"].appversion != "" &&
        response["data"].appversion != null
      ) {
        resolve(response);
      } else {
        reject(response);
      }
    });
  }
  /**
   * Reinto para obtener la geolocalizacion del webview si el componente RSA falla
   */
  retryGeolocalization(): void {
    this.getGeolocalizacion().then(
      (pos) => {
        if (pos) {
          let location = `${pos.lat},${pos.lng}`;
          let date = new Date();
          let data = {
            location: location,
            date: date,
          };
          this.#storageService.set("objGeo", JSON.stringify(data));
        } else {
          const { message, code, status, title, image, icon } =
            CODE_ERRORS["STATUS_RESPONSE_GEO"];
          this.errorMessage({
            message,
            code,
            status,
            title,
            pathImage: image,
            buttonLabel: this.textTokens.ACTIVATE,
            icon: icon,
          });
        }
      },
      (err) => {
        const { message, code, status, title, image, icon } =
          CODE_ERRORS["STATUS_RESPONSE_GEO"];
        this.errorMessage({
          message,
          code,
          status,
          title,
          pathImage: image,
          buttonLabel: this.textTokens.ACTIVATE,
          icon: icon,
        });
      }
    );
  }
  /**
   * Metodo para obtener geolocalizacion
   */
  getGeolocalizacion(): Promise<any> {
    return this.#infoService.getPosition();
  }

  processRequests(response: SSOValidateInterface) {
    console.log('processRequests response:', response);
    if (response.status.statusCode === "SCF000") {
      if (response.data.ke !== null) {
        this.#saveResponse(response);
      } else {
        // Si ke es null pero ya tenemos uno guardado, intentar continuar
        const existingKe = this.#storageService.get("ke");
        if (existingKe && existingKe !== "null") {
          console.warn('KE is null in response but found in storage, continuing with cached ke');
          this.#saveResponse({ ...response, data: { ...response.data, ke: existingKe } });
        } else {
          console.error('KE is null - response.data:', response.data);
          const { message, code, status, title, image, icon } =
            CODE_ERRORS["STATUS_RESPONSE_KE"];
          this.errorMessage({
            message,
            code,
            status,
            title,
            pathImage: image,
            icon: icon,
          });
        }
      }
    } else {
      const message = response["status"].statusDesc;
      const { code, status, title, image, icon } =
        CODE_ERRORS["STATUS_RESPONSE_CAT"];
      const error = response["status"].statusCode + " " + code;
      this.errorMessage({
        message,
        code: error,
        status,
        title,
        pathImage: image,
        icon: icon,
      });
    }
  }

  async #saveResponse(_response: SSOValidateInterface): Promise<void> {
    const { ke, idSessionGopay, buc, appversion } = _response.data;
    const key = ke.slice(-16);
    const iv = ke.slice(0, 16);
    if (ke !== null) {
      this.#storageService.set("ke", ke);
    }
    if (idSessionGopay !== null) {
      this.#storageService.set("idSessionGopay", idSessionGopay);
    }
    if (buc != null) {
      this.#storageService.set("buc", buc);
    }
    if (appversion) {
      this.#storageService.set('appversion', appversion?.replace('for ', ''));
    }
    await this.saveBillers(_response, key, iv);
    await this.saveAccounts(_response, key, iv);
    await this.saveRecharges(_response, key, iv);
    this.#sendTaggin();
    this.#mainService.showSpinner(false);
  }
  /**
   * Guarda el catalogo de billers en local storage
   * @param { SSOValidateInterface } response
   * @param { string } key
   * @param { string } iv
   * @returns void
   */
  async saveBillers(response: SSOValidateInterface, key: string, iv: string): Promise<void> {
    const { billers } = response.data;
    if (billers === null) {
      return;
    }
    const decrypt: string = await this.#cryptoService.Desencriptar(billers, key, iv);
    if (!decrypt?.length) {
      return;
    }
    const billersData = JSON.parse(decrypt) as BillerInterface[];
    this.#ctrlRecharge.billers = billersData
      .filter((_item) => _item.billerId !== "0007")
      .map((_item) => {
        const name = _item.name.includes("-")
          ? _item.name.split("-")[0]
          : _item.name;
        let urlBillerLogo = _item.urlBillerLogo || "";
        if (!_item.urlBillerLogo) {
          urlBillerLogo = logoCompaniesFixture.get(_item.name) || '';
        }
        return { ..._item, name, urlBillerLogo };
      });
  }
  /**
   * Guarda el catalogo de cuentas por cliente  en local storage
   * @param { SSOValidateInterface } response
   * @param { string } key
   * @param { string } iv
   * @returns void
   */
  async saveAccounts(response: SSOValidateInterface, key: string, iv: string): Promise<void> {
    const { accounts } = response.data;
    if (accounts !== null) {
      const decrypt = await this.#cryptoService.Desencriptar(accounts, key, iv);
      if (!decrypt?.length) {
        this.noAccounts();
        return;
      }
      const data = JSON.parse(decrypt) as Accounts[];
      this.#ctrlRecharge.accounts = data.filter(_item => _item.card.cardType.toLowerCase() === 'tdd');
      console.log(this.#ctrlRecharge.accounts, 'saveAccounts');
      if (!this.#ctrlRecharge.accounts.length) {
        this.noAccounts();
        return;
      }
    } else {
      this.noAccounts();
    }
  }

  private noAccounts(): void {
    const { message, code, status, title, image, icon } =
      CODE_ERRORS["NO_ACCOUNTS"];
    console.log('noAccounts');

    this.errorMessage({
      message,
      code,
      status,
      title,
      pathImage: image,
      buttonLabel: "Llamar a SuperLínea",
      icon,
    });
  }

  buildRecharges(): any {
    return this.#ctrlRecharge.recharegesHistory.map(_item => {
      console.log(_item);

      const amount = _item.amount?.replace(/,/g, '');
      console.log(_item);
      return { ..._item, amount };
    });
  }

  async saveRecharges(
    _response: SSOValidateInterface,
    _key: string,
    _iv: string
  ): Promise<void> {
    const { rechargeHistory } = _response.data;
    console.log('saveRecharges: rechargeHistory', rechargeHistory);
    if (!rechargeHistory) {
      console.log('saveRecharges: no rechargeHistory');
      return;
    }
    const decrypt = await this.#cryptoService.Desencriptar(
      rechargeHistory,
      _key,
      _iv
    );
    console.log('saveRecharges: decrypt', decrypt);
    if (!decrypt?.length) {
      console.log('saveRecharges: decrypt empty');
      return;
    }
    this.#ctrlRecharge.recharegesHistory = JSON.parse(
      decrypt
    ) as RechargeHistoryInterface[];
    console.log('saveRecharges: recharegesHistory', this.#ctrlRecharge.recharegesHistory);
    this.rechargeHistory = this.buildRecharges();

  }
  /**
   * Se identifica el numero de tarjeta para asignarle su imagen correspondiente
   * @returns void
   */

  private async buildGeolocalizacion(
    _response: SSOValidateInterface
  ): Promise<void> {
    try {
      const pos = await this.getGeolocalizacion();
      if (pos) {
        let location = `${pos.lat},${pos.lng}`;
        let date = new Date();
        let data = {
          location: location,
          date: date,
        };
        this.#storageService.set("objGeo", JSON.stringify(data));
        this.processRequests(_response);
      } else {
        const { message, code, status, title, image, icon } =
          CODE_ERRORS["STATUS_RESPONSE_GEO"];
        this.errorMessage({
          message,
          code,
          status,
          title,
          pathImage: image,
          buttonLabel: this.textTokens.ACTIVATE,
          icon: icon,
        });
      }
    } catch (error) {
      const { message, code, status, title, image, icon } =
        CODE_ERRORS["STATUS_RESPONSE_GEO"];
      this.errorMessage({
        message,
        code,
        status,
        title,
        pathImage: image,
        buttonLabel: this.textTokens.ACTIVATE,
        icon: icon,
      });
    }
  }

  #handleSSOError(error: any): void {
    const config = {
      key: "STATUS_RESPONSE_TYC",
      button: this.textTokens.UPDATE,
    };
    const isSSOCode = error?.status?.statusCode === "SSOE00";
    if (isSSOCode) {
      config.key = "STATUS_RESPONSE_KE";
      config.button = this.textTokens.ERROR_MESSAGE_ACCEPT;
    }
    const { message, code, status, title, image, icon } =
      CODE_ERRORS[config.key];
    this.errorMessage({
      message,
      code,
      status,
      title,
      pathImage: image,
      buttonLabel: config.button,
      icon: icon,
    });
    this.#mainService.showSpinner(false);
  }

  onNext(_recharge?: RechageType): void {
    let action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "recarga_celular",
      etiqueta: "nueva_recarga",
      canalBanco: "supermovil",
      url: "recarga_celular/",
      userID: "",
    };
    if (_recharge) {
      const { phoneNumber, carrierId, amount, processingDate, idProducto, ...biller } =
        _recharge;
      this.#ctrlRecharge.amount = Number(_recharge.amount);
      this.#ctrlRecharge.biller = biller as BillerInterface;
      this.#ctrlRecharge.phone = _recharge.phoneNumber;
      this.#ctrlRecharge.product = idProducto;
      action = {
        event: "payments",
        categoria: "recarga_celular",
        accion: "ultimas_recargas",
        etiqueta: _recharge.name,
        canalBanco: "supermovil",
        url: "recarga_celular/",
        userID: "",
      };
    }
    this.#taggingService.setEvent(action);
    this.#router.navigateByUrl("/captura");
  }

  getPicture(_biller: RechageType): PictureBasicCardInterface {
    return this.#ctrlRecharge.getPicture(_biller.billerId);
  }
}
